import React from 'react';
import {t} from '@lingui/core/macro';

import Button from 'shared/ui/Button/Button/Button';

import ProgressBar from '../../ProgressBar/ProgressBar';

import styles from './ModalBlockButton.module.scss';

interface IModalBlockButtonProps {
    primaryButtonText?: string;
    primaryButtonType?: 'submit' | 'button';
    primaryButtonOnClick?: () => void;
    primaryButtonLoading?: boolean;
    primaryButtonDisabled?: boolean;
    secondaryButtonText?: string;
    secondaryButtonOnClick?: () => void;
    secondaryButtonLoading?: boolean;
    secondaryButtonDisabled?: boolean;
    progress?: number;
    progressTitle?: string;
}

const ModalBlockButton: React.FC<IModalBlockButtonProps> = ({
    primaryButtonText,
    primaryButtonType,
    primaryButtonOnClick,
    secondaryButtonText = t`Отменить`,
    secondaryButtonOnClick,
    primaryButtonLoading,
    primaryButtonDisabled,
    secondaryButtonLoading,
    secondaryButtonDisabled,
    progress,
    progressTitle,
}) => {

    return (
        <>
            {primaryButtonLoading && progress !== undefined && (
                <ProgressBar
                    percent={progress}
                    title={progressTitle ?? t`Выполняется…`}
                    className={styles.progress}
                />
            )}
            <div className={styles.buttons}>
                <Button
                    type={primaryButtonType}
                    className={styles.primaryButton}
                    onClick={primaryButtonOnClick}
                    loading={primaryButtonLoading}
                    disabled={primaryButtonDisabled}
                    block
                    size="lg"
                >
                    {primaryButtonText}
                </Button>
                <Button
                    variant="secondary"
                    type="button"
                    className={styles.secondaryButton}
                    onClick={secondaryButtonOnClick}
                    loading={secondaryButtonLoading}
                    disabled={secondaryButtonDisabled}
                >
                    {secondaryButtonText}
                </Button>
            </div>
        </>
    );
}

export default ModalBlockButton;
